import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { Switch } from "@progress/kendo-react-inputs";
import AlertBox from "../../components/common/AlertBox";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete } from "react-icons/md";

import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import {
  ActiveInactiveTeamMember,
  deleteTeamMember,
  getAllTeamMember,
} from "./services/teamMember.services";
import { clearTeamMemberID, setTeamMemberID } from "./teamMemberSlice";
import ButtonCreate from "../../components/muidrawer/ButtonCreate";
import ButtonEdit from "../../components/muidrawer/ButtonEdit";
import { Tooltip } from "@mui/material";
import { FaGraduationCap } from "react-icons/fa6";

const TeamMember: React.FC = () => {
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  // const handleCreate = () => {
  //   navigate("/testimonial/create");
  // };

  useEffect(() => {
    dispatch(getAllTeamMember());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  return (
    <>
      <DeleteTeamMemberDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Team Member List
          </Typography.h4>
          {isAddAccess && (
            // <Button
            //   onClick={handleCreate}
            //   fillMode={"solid"}
            //   themeColor={"primary"}
            // >
            //   {"Create Testimonial"}
            // </Button>
            <ButtonCreate
              label="Create Team Member"
              drawerName="teammemberForm"
            />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <TeamMemberGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const TeamMemberGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const TeamMemberList = useAppSelector(
    (state) => state.teammember.TeamMemberList
  );
  const loading = useAppSelector((state) => state.teammember.loading);

  useEffect(() => {
    dispatch(getAllTeamMember());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();
  // const [expandedRow, setExpandedRow] = useState(null);
  // const truncateDescription = (Description: string) => {
  //   if (!Description) return "";
  //   const maxLength = 100;
  //   if (Description.length <= maxLength) return Description;
  //   return Description.substring(0, maxLength) + "...";
  // };

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? TeamMemberList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: any) => {
    // const handleEdit = (ID: number) => {
    //   navigate("/testimonial/edit", { state: { TestimonialID: ID } });
    // };
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteTeamMemeberDialog"));
      dispatch(setTeamMemberID(ID));
    };

    return (
      <td
      {...props.tdProps}
      className={`action-td ${props.className}`}
      style={{ ...props.tdProps.style }}
      >
        {isEditAccess && (
          // <IconButton
          //   type="button"
          //   fillMode="flat"
          //   size="small"
          //   title="Edit"
          //   onClick={() => handleEdit(props.dataItem.ID)}
          // >
          //   <FiEdit
          //     className="absolute-position"
          //     style={{ fontSize: "20px" }}
          //   />
          // </IconButton>
          <ButtonEdit
            ID={props.dataItem.ID}
            name="teammemberForm"
            tooltipTitle="Edit"
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === 9 || props.index === 8 ? "locked-header" : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: any) => {
    const [IsActive, setIsActive] = useState<boolean>(
      props.dataItem.IsActive ?? false
    );

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        ID: props.dataItem.ID,
        IsActive: !IsActive,
      };
      dispatch(ActiveInactiveTeamMember(data)).then((response: any) => {
        // dispatch(getAllTestimonial());
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllTeamMember());
        } else {
          dispatch(getAllTeamMember());
        }
      });
    };

    return (
      <td
      className={`${props.className}`}
      style={{ ...props.tdProps.style, textAlign: "center" }}
      >
        <Switch
          disabled={isEditAccess ? false : true}
          name="IsActive"
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  return (
    <>
    {loading && <LoadingPanel gridRef={gridRef} />}
      {TeamMemberList && TeamMemberList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          filterable={true}
          filter={filter}
          className="responsive-table"
          data={
            filter
              ? filterBy(TeamMemberList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : TeamMemberList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={TeamMemberList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="Name"
            title="Team Member name"
            width={200}
            cells={{
              data: (props: any) => (
                <td>
                  <div className="hoverableName">
                    {isEditAccess ? (
                      <ButtonEdit
                        ID={props.dataItem.ID}
                        name="teammemberForm"
                        label={props.dataItem?.Name}
                      />
                    ) : (
                      <div className="normalName">{props.dataItem?.Name}</div>
                    )}
                  </div>
                </td>
              ),
            }}
          />
          <Column field="SequenceNo" title="Sequence No" width={150} />
          <Column field="Designation" title="Designation" width={200} />
          <Column
            field="xlink"
            title="X Link"
            width={250}
            cells={{
              data: (props: any) => (
                <td>
                  <div
                    className="hoverableName"
                    onClick={() =>
                      window.open(`${props.dataItem.xlink}`, "_black")
                    }
                  >
                    {props.dataItem?.xlink}
                  </div>
                </td>
              ),
            }}
          />
          <Column
            field="Linkedin"
            title="LinkedIn Link"
            width={250}
            cells={{
              data: (props: any) => (
                <td>
                  <div
                    className="hoverableName"
                    onClick={() =>
                      window.open(`${props.dataItem.Linkedin}`, "_black")
                    }
                  >
                    {props.dataItem?.Linkedin}
                  </div>
                </td>
              ),
            }}
          />
          <Column
            field="Facebook"
            title="Facebook Link"
            width={250}
            cells={{
              data: (props: any) => (
                <td>
                  <div
                    className="hoverableName"
                    onClick={() =>
                      window.open(`${props.dataItem.Facebook}`, "_black")
                    }
                  >
                    {props.dataItem?.Facebook}
                  </div>
                </td>
              ),
            }}
          />
          <Column
            field="InstaLink"
            title="Instagram Link"
            width={250}
            cells={{
              data: (props: any) => (
                <td>
                  <div
                    className="hoverableName"
                    onClick={() =>
                      window.open(`${props.dataItem.InstaLink}`, "_black")
                    }
                  >
                    {props.dataItem?.InstaLink}
                  </div>
                </td>
              ),
            }}
          />
          <Column
            field="Image"
            title="Image"
            width={110}
            filterable={false}
            cells={{
              data: (props: any) => (
                <td style={{ textAlign: "center" }}>
                  <Tooltip
                    title={
                      <img
                        src={props.dataItem?.Image}
                        alt="Testimonial Image"
                        width={250}
                        onClick={() => window.open(props.dataItem?.Image)}
                        height={250}
                      />
                    }
                  >
                    {props.dataItem?.Image ? (
                      <img
                        style={{ border: "1px solid grey", padding: "1px" }}
                        src={props.dataItem?.Image}
                        alt="Testimonial Image"
                        width={50}
                        onClick={() => window.open(props.dataItem?.Image)}
                        height={50}
                      />
                    ) : (
                      <>
                        <FaGraduationCap
                          style={{
                            fontSize: "50px",
                            background: "lightgray",
                            padding: "5px",
                            borderRadius: "4px",
                            color: "#163064",
                          }}
                        />
                      </>
                    )}
                  </Tooltip>
                </td>
              ),
            }}
          />
          <Column
            field="ID"
            title="Status"
            cells={{data:MyActiveInActtiveCommandCell}}
            width={"90px"}
            filterable={false}
            locked={true}
          />
          {(isEditAccess || isDeleteAccess) && (
            <Column
              field="ID"
              title="Actions"
              cells={{data:MyEditCommandCell}}
              width={"110px"}
              locked={true}
              filterable={false}
            />
          )}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const DeleteTeamMemberDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const TeamMemberID = useAppSelector((state) => state.teammember.TeamMemberID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteTeamMember(ID));
      if (response.payload.Data.Status === 200) {
        dispatch(getAllTeamMember());
        dispatch(closeDialog());
        dispatch(clearTeamMemberID());
      } else {
        dispatch(getAllTeamMember());
        dispatch(closeDialog());
        dispatch(clearTeamMemberID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteTeamMemeberDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Team Member"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Team Member ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(TeamMemberID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default TeamMember;
